import React, { useState } from 'react';
import { auth } from '../config/firebaseConfig'; // Firebase auth'u import et
import { updateProfile, updateEmail, updatePassword } from 'firebase/auth'; // Kullanıcı bilgilerini güncelleme fonksiyonları

const KullaniciDuzenle = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Mevcut kullanıcı bilgilerini al
  const currentUser = auth.currentUser;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // E-posta adresini güncelleme
      if (email && email !== currentUser.email) {
        await updateEmail(currentUser, email);
      }

      // Şifreyi güncelleme
      if (password) {
        await updatePassword(currentUser, password);
      }

      // Display name (isim) güncelleme
      if (displayName && displayName !== currentUser.displayName) {
        await updateProfile(currentUser, { displayName });
      }

      setSuccess('Kullanıcı başarıyla güncellendi!');
    } catch (error) {
      setError('Bir hata oluştu: ' + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="container-fluid">
      <h1 className="h3 mb-4 text-gray-800">Kullanıcı Düzenle</h1>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">Kullanıcı Bilgilerini Düzenle</h6>
        </div>
        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="displayName">İsim</label>
              <input
                type="text"
                className="form-control"
                id="displayName"
                value={displayName || currentUser.displayName || ''}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="Kullanıcı ismi"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">E-posta</label>
              <input
                type="email"
                className="form-control"
                id="email"
                value={email || currentUser.email || ''}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-posta adresini girin"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Yeni Şifre</label>
              <input
                type="password"
                className="form-control"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Yeni şifre girin (isteğe bağlı)"
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Yükleniyor...' : 'Kullanıcıyı Güncelle'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default KullaniciDuzenle;
